import _this from "../../main";
import router from '../../router';
import moment from 'moment';

export default {
  install(Vue) {


    //返回上一页
    Vue.prototype.backToPrevpage = function () {
      // alert(_this.$store.state.browser.ios);
      // alert("M:" + _this.$store.state.browser.m);
      // alert(window.navigator.userAgent);
      // console.log(_this.$store.state);
      if( history.length > 2 ){
        let tmpHref = location.href;
        //router.go(-1);
        history.back();

        // alert("ios：" + (_this.$store.state.browser.ios ? 1 : 0));
        // alert("tmpHref：" + tmpHref);
        // alert("href：" + location.href);

        // if( !_this.$store.state.browser.ios && tmpHref == location.href ){
        //   router.push({path: '/'});
        // } else {
          
        // }
      } else {
        router.push({path: '/'});
      }
    };

    //复制到剪贴板
    Vue.prototype.copyToClipboard = function (content){

      const textString = content.toString();//数字没有 .length 不能执行selectText 需要转化成字符串
      let input = document.querySelector('#copy-input');
      if (!input) {
        input = document.createElement('input');
        input.id = "copy-input";
        input.readOnly = "readOnly";        // 防止ios聚焦触发键盘事件
        input.style.position = "absolute";
        input.style.left = "-1000px";
        input.style.zIndex = "-1000";
        document.body.appendChild(input)
      }
  
      input.value = textString;
      // ios必须先选中文字且不支持 input.select();
      selectText(input, 0, textString.length);
      console.log(document.execCommand('copy'), 'execCommand');
      if (document.execCommand('copy')) {
        document.execCommand('copy');
        //alert('已复制到粘贴板');
      }
      input.blur();
  
      // input自带的select()方法在苹果端无法进行选择，所以需要自己去写一个类似的方法
      // 选择文本。createTextRange(setSelectionRange)是input方法
      function selectText(textbox, startIndex, stopIndex) {
        if (textbox.createTextRange) {//ie
          const range = textbox.createTextRange();
          range.collapse(true);
          range.moveStart('character', startIndex);//起始光标
          range.moveEnd('character', stopIndex - startIndex);//结束光标
          range.select();//不兼容苹果
        } else {//firefox/chrome
          textbox.setSelectionRange(startIndex, stopIndex);
          textbox.focus();
        }
      }

      /*
      if (window.clipboardData) {
        window.clipboardData.setData('text', content);
      } else {
        (function (content) {
          document.oncopy = function (e) {
            e.clipboardData.setData('text', content);
            e.preventDefault();
            document.oncopy = null;
          }
        })(content);
        document.execCommand('Copy');
      }
      */
    };



    //页面滚动到，全局函数
    //https://stackoverflow.com/questions/21474678/scrolltop-animation-without-jquery
    Vue.prototype.scrollToTop = function (duration = 500, targettop = 100, linear = false){
      // cancel if already on top
      if (document.scrollingElement.scrollTop === targettop) return;
      if( linear ){
        const cosParameter = document.scrollingElement.scrollTop - targettop;
        let scrollY = cosParameter, oldTimestamp = null;
        let firstTimestamp = null;//通过时间戳判断何时终止
        function step (newTimestamp) {
          if ( firstTimestamp === null ){
            firstTimestamp = newTimestamp;
          }
          if (oldTimestamp !== null) {
            scrollY -= cosParameter * (newTimestamp - oldTimestamp) / duration;
            //if (scrollY > -10 && scrollY < 10) return document.scrollingElement.scrollTop = targettop;
            if (oldTimestamp - firstTimestamp >= duration) return document.scrollingElement.scrollTop = targettop;
            document.scrollingElement.scrollTop = targettop + scrollY;
          }
          oldTimestamp = newTimestamp;
          window.requestAnimationFrame(step);
        }
        window.requestAnimationFrame(step);
      } else {
        const cosParameter = (targettop - document.scrollingElement.scrollTop) / 2;
        let scrollCount = 0, oldTimestamp = null;
        function step (newTimestamp) {
          if (oldTimestamp !== null) {
            // if duration is 0 scrollCount will be Infinity
            scrollCount += Math.PI * (newTimestamp - oldTimestamp) / duration;
            if (scrollCount >= Math.PI) return document.scrollingElement.scrollTop = targettop;
            document.scrollingElement.scrollTop = targettop - (cosParameter + cosParameter * Math.cos(scrollCount));
          }
          oldTimestamp = newTimestamp;
          window.requestAnimationFrame(step);
        }
        window.requestAnimationFrame(step);
      }
    };

    //通过经纬度计算距离，返回公里数
    Vue.prototype.calcDistance = function (lat1, lng1, lat2, lng2){
      function Rad(d){
        return d * Math.PI / 180.0;//经纬度转换成三角函数中度分表形式。
      }
      var radLat1 = Rad(lat1);
      var radLat2 = Rad(lat2);
      var a = radLat1 - radLat2;
      var  b = Rad(lng1) - Rad(lng2);
      var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a/2),2) +
      Math.cos(radLat1)*Math.cos(radLat2)*Math.pow(Math.sin(b/2),2)));
      s = s *6378.137 ;// EARTH_RADIUS;
      s = Math.round(s * 10000) / 10000; //输出为公里
      //s=s.toFixed(4);
      return s;
    };

    //获取用户当前位置（定位）
    Vue.prototype.getUserPostion = function (mustReFresh = false, fnCallback, fnError){
      

      if( !mustReFresh ){//非强制刷新
        let tmpUserpostion = JSON.parse(localStorage.getItem('giant_userpostion'));
        if( tmpUserpostion && tmpUserpostion.lat ){
          fnCallback && fnCallback(tmpUserpostion);
        } else {
          _this.getUserPostion( true, fnCallback, fnError );
        }
        return false;
      }

      window.onGaodeLoad = function(){
        _this.getUserPostion( mustReFresh, fnCallback, fnError );
      }
      if( typeof(AMap) =="undefined" ){
        var url = 'https://webapi.amap.com/maps?v=2.0&key=d94102a2b4b53d8d81de63aec201ae4a&callback=onGaodeLoad';
        var jsapi = document.createElement('script');
        jsapi.charset = 'utf-8';
        jsapi.src = url;
        document.head.appendChild(jsapi);
      } else {
        let map, geolocation;
        map = new AMap.Map(document.createElement('div'), {
          //resizeEnable: true
        });
        map.plugin('AMap.Geolocation', function() {
          geolocation = new AMap.Geolocation({
            enableHighAccuracy: true, //是否使用高精度定位，默认:true
            timeout: 10000, //超过10秒后停止定位，默认：无穷大
          });
          geolocation.getCurrentPosition(function(status, result){
            if(status=='complete'){
              //console.log(result.position);
              
              let userpostion_data = {
                lat: result.position.getLat(),//高精 //result.position.lat
                lng: result.position.getLng(),//高精 //result.position.lng
              }
              //console.log(userpostion_data);
  
              //本地存储
              localStorage.setItem('giant_userpostion', JSON.stringify(userpostion_data));//session

              fnCallback && fnCallback(userpostion_data);
  
            } else {
              //onError(result)
              //alert(2);
              fnError && fnError(result);
            }
          });
        });

      }


    };

    //美化价格的显示 num 待美化的价格 fixed 几位小数 round 四舍五入 thousand 千位符
    Vue.prototype.priceSexy = function(num, fixed = 2, round = true, thousand = false){
      if( isNaN(num) ){
        return num;
      }
      if( fixed >= 0 ){
        if(round){
          num = (Number(num)).toFixed(fixed);
        } else {
          num = (Math.floor(num * 100) / 100).toFixed(fixed);
        }
      }
      if( thousand ){
        var numarr = num.split(".");
        if( numarr.length ) {
          num = (numarr[0] || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
        }
        if( numarr.length > 1 && numarr[1]!="" ) {
          num = "" + num + "." + numarr[1];
        }
      }
      return num;
    };

    //计算 解决js运算bug
    Vue.prototype.mathcalc = function (a, b, mode = '+'){
      
      if( mode == '-' ){//=========================
        let c, d, e;
        try {
          c = a.toString().split('.')[1].length;
        } catch (f) {
          c = 0;
        }
        try {
          d = b.toString().split('.')[1].length;
        } catch (f) {
          d = 0;
        }
        return e = Math.pow(10, Math.max(c, d)), (_this.mathcalc(a, e, '*') - _this.mathcalc(b, e, '*')) / e;
      } else if( mode == '*' ){//=========================
        let c = 0,
        d = a.toString(),
        e = b.toString();
        try {
          c += d.split('.')[1].length;
        } catch (f) {}
        try {
          c += e.split('.')[1].length;
        } catch (f) {}
        return Number(d.replace('.', '')) * Number(e.replace('.', '')) / Math.pow(10, c);
      } else if( mode == '/' ){//=========================
        let c, d, e = 0,f = 0;
        try {
          e = a.toString().split('.')[1].length;
        } catch (g) {}
        try {
          f = b.toString().split('.')[1].length;
        } catch (g) {}
        return c = Number(a.toString().replace('.', '')), d = Number(b.toString().replace('.', '')), _this.mathcalc(c / d, Math.pow(10, f - e), '*');
      } else {//=========================
        let c, d, e;
        try {
          c = a.toString().split('.')[1].length;
        } catch (f) {
          c = 0;
        }
        try {
          d = b.toString().split('.')[1].length;
        } catch (f) {
          d = 0;
        }
        return e = Math.pow(10, Math.max(c, d)), (_this.mathcalc(a, e, '*') + _this.mathcalc(b, e, '*')) / e;
      }
    };

    //格式化时间戳
    Vue.prototype.dateformat = function(dataStr, pattern = 'YYYY-MM-DD HH:mm:ss'){
      if( dataStr.toString().length < 13 ){
        dataStr *= 1000;
      }
      return moment(dataStr).format(pattern);
    };

    //base64转Blob
    Vue.prototype.dataURItoBlob = function (dataURI) {
      var byteString = atob(dataURI.split(',')[1]);
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
      var ab = new ArrayBuffer(byteString.length);
      var ia = new Uint8Array(ab);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ab], { type: mimeString });
    };

    //压缩图片
    //width 宽、height 高、quality 质量、longside 长边（优先级高过宽高）、shortside 短边（优先级最高）
    Vue.prototype.compressImage = function (file, callback, config){
      
      if (file.type == 'image/gif' || file.type == 'image/jpeg' || file.type == 'image/pjpeg' || file.type == 'image/png' || file.type == 'image/x-png') {

        let tmpParams = {
          width: 1000,
          quality: 0.8
        };

        tmpParams = Object.assign(tmpParams, config);

        //通过canvas压缩图片
        var reader = new FileReader();
        reader.readAsDataURL(file.file);
        var img = new Image;
        reader.onload = function (e) {
          //var width = 1080; //图像大小
          //var quality = 0.8; //图像质量
          var canvas = document.createElement("canvas");
          var drawer = canvas.getContext("2d");
          img.src = this.result;
          img.onload = function () {
            canvas.width = img.width;
            canvas.height = img.height;

            if( tmpParams.shortside ){
              if( img.width > img.height ){
                tmpParams.height = tmpParams.shortside;
                tmpParams.width = tmpParams.height * (img.width / img.height);
              } else if( img.height > img.width ){
                tmpParams.width = tmpParams.shortside;
                tmpParams.height = tmpParams.width * (img.height / img.width);
              }
            }else if( tmpParams.longside ){
              tmpParams.width = tmpParams.height = tmpParams.longside;
            }
            if( tmpParams.width && tmpParams.width < img.width ){
              canvas.width = tmpParams.width;
              canvas.height = tmpParams.width * (img.height / img.width);
            }
            if( tmpParams.height && tmpParams.height < canvas.height ){
              canvas.height = tmpParams.height;
              canvas.width = tmpParams.height * (img.width / img.height);
            }
            drawer.drawImage(img, 0, 0, canvas.width, canvas.height);
            let tmpType = 'image/jpeg';
            if( file.file.type == 'image/png' || file.file.type == 'image/x-png' ){
              tmpType = 'image/png';
            }
            file.file = new window.File([_this.dataURItoBlob(canvas.toDataURL(tmpType, tmpParams.quality))], file.file.name, {type: file.file.type});
            callback && callback(file);
          }
        }
      } else {
        callback && callback(file);
      }
    };

    //判断字符串中是否有超过2字节的字符（是否有emoji表情）
    Vue.prototype.is32Bit = function (substring) {
      for (var i = 0; i < substring.length; i++) {
        if( substring.codePointAt(i) > 0xFFFF){
          return true;
        }
      }
      return false;
    };

    //判断字符串中多少个字节
    Vue.prototype.stringByteCount = function (substring) {
      if(!arguments.length||!substring) return null;
      if(''==substring) return 0;
      var l=0;
      for(var i=0;i<substring.length;i++){
        if(substring.charCodeAt(i)>255) l+=2;
        else l++;
      }
      return l;
    };


    //截取并返回第一个品牌名
    Vue.prototype.splitBrandText = function (str) {
      if(typeof str == "string"){
        var tmpArr = str.split("/");
        return tmpArr[0];
      } else {
        return "";
      }
    };



  }
}







// WEBPACK FOOTER //
// ./src/assets/js/site.js